var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"full-area padded vertically-centered desktop-wrapper"},[_c('SensataSplash')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }